"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apiEnv = _interopRequireDefault(require("../../../api/api-env"));
var _searchModule = require("../shared-components/search-module");
var _reactIntl = require("react-intl");
var _sharedIntlProviderHOC = _interopRequireDefault(require("../shared-components/hocs/sharedIntlProviderHOC"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var withActivityDropdownHoc = function withActivityDropdownHoc(Component) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);
    function HOC(props) {
      var _this;
      _classCallCheck(this, HOC);
      _this = _callSuper(this, HOC, [props]);
      _this.initialState = {
        activity: '',
        activityId: '',
        activities: [],
        activitiesList: [],
        placeholder: _this.props.intl.formatMessage({
          id: 'elements_search_module.with_activity_dropdown_hoc.what_planning',
          defaultMessage: 'What are you planning?'
        }),
        showModal: false,
        placeholderColor: 'placeholder-color-change'
      };
      _this.state = _this.initialState;
      _this.onFocusActivity = _this.onFocusActivity.bind(_assertThisInitialized(_this));
      _this.onBlurActivity = _this.onBlurActivity.bind(_assertThisInitialized(_this));
      _this.onChangeActivity = _this.onChangeActivity.bind(_assertThisInitialized(_this));
      _this.onClickActivity = _this.onClickActivity.bind(_assertThisInitialized(_this));
      _this.toggleModal = _this.toggleModal.bind(_assertThisInitialized(_this));
      _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
      _this.onInputOnclick = _this.onInputOnclick.bind(_assertThisInitialized(_this));
      _this.matchActivity = _this.matchActivity.bind(_assertThisInitialized(_this));
      return _this;
    }
    _createClass(HOC, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        var activity = _.get(this.props, 'selectedFilters.useTypeObj', '');
        var activityId = _.get(this.props, 'selectedFilters.useTypeId', '');
        /* setting search keyword cookie when user lands on this page directly */
        if (PSSessions) {
          PSSessions.set.thisCookie('PSSK', activity, Date.now() + 3888000000);
        }
        var locale = _sharedIntlProviderHOC.default.getLocale();
        _apiEnv.default.getActivities(locale, function (res) {
          var activities = res.response;
          var match = _this2.matchActivity(activities, activityId);
          var preFillActivityDropdown = _.get(match, 'dropdown');
          var preFillActivityId = _.get(match, 'id');
          _this2.setState({
            activity: activity && preFillActivityDropdown,
            activityId: activityId && preFillActivityId,
            activities: activities,
            activitiesList: []
          });
        });
        // we pass typeAheadInput up to the parent component and becomes this.activityRef ex: (hero component)
        this.props.activityRef(this.typeAheadInput);
      }
    }, {
      key: "matchActivity",
      value: function matchActivity(activities, activityId) {
        // tries to find an exact match of activities based on ID
        // if none is found, then we use sifter to find a close approximation
        var match = {};
        var exactMatch = activities && activities.find(function (act) {
          return act.id === activityId;
        });
        if (exactMatch) {
          match = exactMatch;
        } else {
          var sifter = new Sifter(activities);
          var fuzzyMatch = sifter.search(activityId, {
            fields: ['id'],
            limit: 1
          }).items || [];
          var matchSifterId = _.get(fuzzyMatch, '[0].id');
          match = _.get(activities, "[".concat(matchSifterId, "]"));
        }
        return match;
      }
    }, {
      key: "onChangeActivity",
      value: function onChangeActivity(e) {
        var _this3 = this;
        var activities = this.state.activities;
        var activity = e.currentTarget.value;
        this.setState({
          activity: activity
        }, function () {
          if (activity) return _this3.getActivitySuggestions(activity);
          return _this3.setState({
            activityId: '',
            activitiesList: []
          });
        });
      }
    }, {
      key: "onFocusActivity",
      value: function onFocusActivity() {
        var activity = this.state.activity;
        this.setState({
          placeholder: this.props.intl.formatMessage({
            id: 'elements_search_module.with_activity_dropdown_hoc.enter_activity',
            defaultMessage: 'Enter your activity'
          }),
          placeholderColor: ''
        });
        if (activity) return this.getActivitySuggestions(activity);
        return null;
      }
    }, {
      key: "onClickActivity",
      value: function onClickActivity(e, closeDropdownOrModal) {
        var _this4 = this;
        if (e) {
          e.stopPropagation();
          e.preventDefault();
        }
        var activityId = _.get(e, 'currentTarget.dataset.value', '');
        var filteredActivity = _.filter(this.state.activities, {
          id: activityId
        })[0] || {};
        var activity = filteredActivity.dropdown;
        var skt = this.state.activity ? 'input' : 'default';
        PSSessions.Cookies.set('PSSK', activity, Date.now() + 3888000000);
        PSSessions.Cookies.set('PSSKT', skt, Date.now() + 3888000000);
        if (_.isFunction(closeDropdownOrModal)) closeDropdownOrModal();
        setTimeout(function () {
          _this4.setState({
            activity: activity,
            activityId: activityId
          });
          if (_.isFunction(_this4.props.filterResults)) {
            _this4.props.filterResults({
              a: activity
            });
          }
        }, 200);
      }
    }, {
      key: "onBlurActivity",
      value: function onBlurActivity(e) {
        if (e) e.stopPropagation();
        this.setState({
          placeholder: this.initialState.placeholder,
          placeholderColor: this.initialState.placeholderColor
        });
      }
    }, {
      key: "onKeyDown",
      value: function onKeyDown(e) {
        var firstOnList = document.getElementById('activity-list-0');
        if (40 === e.keyCode && firstOnList) {
          // If user presses the down arro\w,
          // we select the first item from the dropdown
          e.preventDefault();
          firstOnList.focus();
        } else if (13 === e.keyCode && firstOnList) {
          // If user hits enter, we select the first item from the dropdown,
          // and blur out of the input field
          firstOnList.click();
          e.target.blur();
        }
      }
    }, {
      key: "onInputOnclick",
      value: function onInputOnclick(e) {
        if (e) {
          e.stopPropagation();
          e.preventDefault();
          e.target.select();
        }
      }
    }, {
      key: "getActivitySuggestions",
      value: function getActivitySuggestions(input) {
        var _window = window,
          Sifter = _window.Sifter;
        var _this$state = this.state,
          activities = _this$state.activities,
          activityId = _this$state.activityId;
        var siftedActivity = new Sifter(activities).search(input, {
          fields: ['dropdown', 'use-subtype', 'display_use_type'],
          limit: 5
        });
        var activitiesList = !_.isEmpty(siftedActivity) ? _.map(siftedActivity.items, function (item) {
          return activities[item.id];
        }) : [];
        this.setState({
          activityId: activitiesList.length ? activityId : '',
          activitiesList: activitiesList
        });
      }
    }, {
      key: "toggleModal",
      value: function toggleModal(e, listToggle) {
        if (e) e.preventDefault();
        var showModal = this.state.showModal;
        if (_.isFunction(listToggle)) listToggle();
        this.setState({
          showModal: !showModal
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this5 = this;
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Component, {
          inputOverlayRef: function inputOverlayRef(e) {
            _this5.typeAheadInput = e;
          },
          activityValue: this.state.activity,
          activity: this.state.activity,
          activityId: this.state.activityId,
          activitiesList: this.state.activitiesList,
          placeholder: this.state.placeholder,
          onFocusActivity: this.onFocusActivity,
          onBlurActivity: this.onBlurActivity,
          onClickActivity: this.onClickActivity,
          onChangeActivity: this.onChangeActivity,
          toggleModal: this.toggleModal,
          onKeyDown: this.onKeyDown,
          inputRef: this.props.inputRef,
          inputClassName: "".concat(this.props.inputClassName, " ").concat(this.state.placeholderColor),
          inputAttributes: {
            onClick: this.onInputOnclick
          },
          addOnImage: this.props.addOnImage,
          hideErrorDropdown: !this.state.activity
        }), /*#__PURE__*/_react.default.createElement(_searchModule.ActivityModal, {
          showModal: this.state.showModal,
          activities: this.state.activities,
          onClickActivity: this.onClickActivity,
          closeModal: this.toggleModal
        }));
      }
    }]);
    return HOC;
  }(_react.default.Component);
  HOC.propTypes = {
    filterResults: _propTypes.default.func,
    inputClassName: _propTypes.default.string,
    inputRef: _propTypes.default.func,
    activityRef: _propTypes.default.func,
    addOnImage: _propTypes.default.object
  };
  return (0, _reactIntl.injectIntl)(HOC);
};
var _default = exports.default = withActivityDropdownHoc;